export const gallery = [
  {
    id: 1,
    imageSrc: "/gallery/1.jpeg",
  },
  {
    id: 2,
    imageSrc: "/gallery/7.jpeg",
  },
  {
    id: 3,
    imageSrc: "/gallery/3.jpeg",
  },
  {
    id: 4,
    imageSrc: "/gallery/4.jpeg",
  },
  {
    id: 5,
    imageSrc: "/gallery/5.jpeg",
  },
  {
    id: 6,
    imageSrc: "/gallery/6.jpeg",
  },
  {
    id: 7,
    imageSrc: "/gallery/2.jpeg",
  },
  {
    id: 8,
    imageSrc: "/gallery/8.jpeg",
  },
  {
    id: 9,
    imageSrc: "/gallery/17.jpeg",
  },
  {
    id: 10,
    imageSrc: "/gallery/20.jpeg",
  },
  {
    id: 11,
    imageSrc: "/gallery/11.jpeg",
  },
  {
    id: 12,
    imageSrc: "/gallery/12.jpeg",
  },
  {
    id: 13,
    imageSrc: "/gallery/13.jpeg",
  },
  {
    id: 14,
    imageSrc: "/gallery/14.jpeg",
  },
  {
    id: 15,
    imageSrc: "/gallery/15.jpeg",
  },
  {
    id: 16,
    imageSrc: "/gallery/16.jpeg",
  },
  {
    id: 17,
    imageSrc: "/gallery/9.jpeg",
  },
  {
    id: 18,
    imageSrc: "/gallery/18.jpeg",
  },
  {
    id: 19,
    imageSrc: "/gallery/19.jpeg",
  },
  {
    id: 20,
    imageSrc: "/gallery/10.jpeg",
  },
  {
    id: 21,
    imageSrc: "/gallery/21.jpeg",
  },
  {
    id: 22,
    imageSrc: "/gallery/22.jpeg",
  },
  {
    id: 23,
    imageSrc: "/gallery/23.jpeg",
  },
  {
    id: 24,
    imageSrc: "/gallery/24.jpeg",
  },
  {
    id: 25,
    imageSrc: "/gallery/25.jpeg",
  },
  {
    id: 26,
    imageSrc: "/gallery/26.jpeg",
  },
  {
    id: 27,
    imageSrc: "/gallery/27.jpeg",
  },
  {
    id: 28,
    imageSrc: "/gallery/28.jpeg",
  },
  {
    id: 29,
    imageSrc: "/gallery/29.jpeg",
  },
  {
    id: 30,
    imageSrc: "/gallery/30.jpeg",
  },
  {
    id: 31,
    imageSrc: "/gallery/31.jpeg",
  },
  {
    id: 32,
    imageSrc: "/gallery/32.jpeg",
  },
  {
    id: 33,
    imageSrc: "/gallery/33.jpeg",
  },
  {
    id: 34,
    imageSrc: "/gallery/34.jpeg",
  },
  {
    id: 35,
    imageSrc: "/gallery/35.jpeg",
  },
  {
    id: 36,
    imageSrc: "/gallery/36.jpeg",
  },
  {
    id: 37,
    imageSrc: "/gallery/37.jpeg",
  },
  {
    id: 38,
    imageSrc: "/gallery/38.jpeg",
  },
  {
    id: 39,
    imageSrc: "/gallery/39.jpeg",
  },
  {
    id: 40,
    imageSrc: "/gallery/40.jpeg",
  },
  {
    id: 41,
    imageSrc: "/gallery/41.jpeg",
  },
  {
    id: 42,
    imageSrc: "/gallery/42.jpeg",
  },
  {
    id: 43,
    imageSrc: "/gallery/43.jpeg",
  },
  {
    id: 44,
    imageSrc: "/gallery/44.jpeg",
  },
  {
    id: 45,
    imageSrc: "/gallery/45.jpeg",
  },
  {
    id: 46,
    imageSrc: "/gallery/46.jpeg",
  },
  {
    id: 47,
    imageSrc: "/gallery/47.jpeg",
  },
  {
    id: 48,
    imageSrc: "/gallery/48.jpeg",
  },
  {
    id: 49,
    imageSrc: "/gallery/49.jpeg",
  },
  {
    id: 50,
    imageSrc: "/gallery/50.jpeg",
  },
  {
    id: 51,
    imageSrc: "/gallery/51.jpeg",
  },
  {
    id: 52,
    imageSrc: "/gallery/52.jpeg",
  },
  {
    id: 53,
    imageSrc: "/gallery/53.jpeg",
  },
  {
    id: 54,
    imageSrc: "/gallery/54.jpeg",
  },
  {
    id: 55,
    imageSrc: "/gallery/55.jpeg",
  },
  {
    id: 56,
    imageSrc: "/gallery/56.jpeg",
  },
  {
    id: 57,
    imageSrc: "/gallery/57.jpeg",
  }
];
